import { Flex, Image } from "@chakra-ui/react";
import React from "react";
import BasicLayout from "../../components/Layouts/BasicLayout";

const Index = () => {
  return (
    <BasicLayout>
      <Flex
        h="80vh"
        w="100%"
        justify="center"
        align="center"
        p="10"
        direction="column"
      >
        <Image
          src="/404.svg"
          maxW="100%"
          height="80%"
          alt="404 not found image"
        ></Image>
        <p style={{ fontSize: "34px" }}> सापडले नाही</p>
      </Flex>
    </BasicLayout>
  );
};

export default Index;
